import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: 32,
    position: 'relative',
    overflowWrap: 'anywhere'
  },
  separator: {
    width: '100%',
    borderBottom: `1px solid ${theme.colorPalette.beige_50}`,
    marginBottom: theme.spacing(4),
    ...reskinStyles(theme, { borderBottom: `1px solid ${theme.colors.card_divider}` })
  },
  copyButtonLabel: {
    textTransform: 'uppercase',
    fontWeight: 600
  }
}));

export default useStyles;
